<template>
	<div class="mainWrapper direct-purchase">
		<h1>Create Product Transfer</h1>
		<div class="form" v-if="brands.length > 0">
			<div>
				<span class="label">SHOP FROM</span>
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="brandAutocomplete"
					:disabled="products.length > 0"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>

			<div>
				<span class="label">BRAND</span>
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
					:disabled="products.length > 0"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>

			<div v-if="selectedBrand">
				<span class="label">BD CODE</span>
				<div class="addDetails">
					<b-autocomplete
						:data="searchData"
						placeholder="BD Code"
						field="bd_code"
						@typing="searchProducts"
						@select="option => (product = option)"
						class="brandAutocomplete"
					>
						<template slot="empty">No results found</template>
					</b-autocomplete>
				</div>
			</div>

			<div v-if="product">
				<span class="label">ADD</span>
				<b-button type="is-info" icon-left="plus-circle-outline" @click="submit">ADD PRODUCT</b-button>
			</div>
		</div>

		<div class="transfer-date">
			<span class="label">TRANSFER DATE</span>
			<b-datepicker :date-formatter="dateFormatter" v-model="transferDate" icon="calendar-today"> </b-datepicker>
		</div>

		<div class="list">
			<!-- v-if="products.length > 0" -->
			<div class="product-transfer-list header">
				<div>
					BD CODE
				</div>

				<div>
					BARCODE
				</div>

				<div>
					NAME
				</div>

				<div>
					PACKAGING
				</div>

				<div>
					QUANTITY
				</div>

				<!-- <div>
					PRICE
				</div> -->

				<div>
					REMARK
				</div>
			</div>

			<div v-for="(item, index) of products" v-bind:key="index" class="product-transfer-list">
				<div>
					{{ item.bd_code }}
				</div>

				<div>
					{{ item.barcode }}
				</div>

				<div>
					{{ item.name }}
				</div>

				<div>
					<b-select v-model="item.packaging_selection" disabled>
						<option :value="item.packaging_selection">
							{{ getPackagingSelectionDisplay(item) }}
						</option>
					</b-select>
				</div>

				<div>
					<input name="qtyInput" class="qtyInput" type="number" v-on:change="update(index, 'qty', $event.target.value)" />
				</div>

				<div>
					<textarea name="remark" class="remark" placeholder="Remark" v-model="item.remark" />
				</div>

				<div>
					<button class="remove-button" @click="removeItem(index)">Remove</button>
				</div>
			</div>
		</div>

		<div v-if="products.length > 0" class="detail-buttons-wrapper">
			<div></div>
			<div class="align-right">
				<button class="big-button" @click="save()">SAVE</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AddDirectPurchase',
	data: function() {
		return {
			brands: [], // List of brands from API
			selectedBrand: null, // Selected brand
			bdcodeData: [], // API bdcode data,
			transferDate: null,
			searchData: [], // API Search data
			brandSuggestions: '', // List of brands
			product: null, // 1 selected product
			products: [], // Selected products
			name: null,
			supplier: null,
			shops: [],
			shopsSuggestions: '',
			selectedShop: null,
			warehouse: null
		}
	},

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	watch: {
		// product: function(newData) {
		// 	console.log(newData)
		// },

		selectedBrand: function(newData) {
			this.product = null
			this.products = []
		}
	},

	mounted: async function() {
		// Get list of brands
		const data = {
			populate: ['suppliers']
		}

		await this.getShops()

		const apiGetWarehouse = await this.$api.getWarehouse({ data })

		this.warehouse = apiGetWarehouse.data._id

		this.supplier = apiGetWarehouse.data.suppliers[0]._id

		// Get brands name which are related to this warehouse
		await Promise.all(
			apiGetWarehouse.data.suppliers[0].brand.map(async brand => {
				const brandData = {
					id: brand
				}

				const apiGetBrand = await this.$api.getBrand({ data: brandData })

				if (apiGetBrand !== undefined) {
					this.brands.push(apiGetBrand.data.list[0])
				}
			})
		)
	},

	methods: {
		removeItem: function(index) {
			this.products.splice(index, 1)
		},

		save: async function() {
			// Make sure transfer date is not blank
			if (!this.transferDate) {
				this.$swal.fire('Error!', 'Transfer Date is required!', 'error')

				return
			}

			// Make sure products quantities are not blank
			for (const product of this.products) {
				if (product.qty == null || product.qty == '') {
					this.$swal.fire('Error!', product.bd_code + ' quantity cannot be blank', 'error')

					return
				}
			}

			let data = {
				warehouse: this.warehouse,
				shop_to: this.selectedShop._id,
				brand: this.selectedBrand._id,
				transfer_date: this.$moment(this.transferDate).format('DD/MM/YYYY'),
				product: []
			}

			this.products.map(product => {
				var productData = {}

				productData.id = product._id
				productData.stock = product.qty

				// Add packaging selection with fallback priority
				productData.packaging_selection = product.packaging_selection || this.getPackagingSelection(product)

				if (product.remark) {
					productData.remark = product.remark
				}

				data.product.push(productData)
			})

			const apiSave = await this.$api.saveProductTransfer({ data })

			if (apiSave) {
				this.$swal.fire(apiSave.data.code)

				this.$router.push('/product-transfer')
			} else {
				this.$swal.fire('Error!', 'Something is wrong!', 'error')
			}
		},

		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		submit: async function() {
			this.product.received_date = null
			this.product.qty = null
			this.product.remark = null

			// Auto-select packaging based on priority: packaging.base_unit -> original_price_unit -> single_item
			this.product.packaging_selection = this.getPackagingSelection(this.product)

			const duplicate = this.products.filter(product => {
				return product._id == this.product._id
			})

			if (duplicate.length > 0) {
				this.$swal.fire('Duplicate!', this.product.bd_code + ' is already added!', 'error')

				return
			}

			this.products.push(this.product)

			this.product = null
			this.searchData = []
		},

		update: function(index, item, value) {
			if (item == 'qty') {
				this.products[index].qty = Number(value)
			}

			// if (item == "price") {
			// 	this.products[index].price = Number(value);
			// }
		},

		// Autocomplete search
		searchProducts: async function(name) {
			if (name.length > 1) {
				let data = {
					brand: this.selectedBrand._id,
					bd_code: name
				}

				const apiSearchProduct = await this.$api.searchProduct({ data })

				this.searchData = apiSearchProduct.data.list

				// If no data found, try to search with barcode
				if (apiSearchProduct.data.list && apiSearchProduct.data.list.length < 1) {
					delete data.bd_code

					data.barcode = name

					const apiSearchProduct = await this.$api.searchProduct({ data })

					this.searchData = apiSearchProduct.data.list
				}
			}
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		// Get packaging selection with fallback priority: packaging.base_unit -> original_price_unit -> single_item
		getPackagingSelection: function(product) {
			// First priority: packaging.base_unit
			if (product && product.packaging && product.packaging.base_unit) {
				return product.packaging.base_unit
			}
			// Second priority: original_price_unit
			if (product && product.original_price_unit) {
				return product.original_price_unit
			}
			// Final fallback: single_item
			return 'single_item'
		},

		// Get packaging selection display text for the dropdown
		getPackagingSelectionDisplay: function(product) {
			// First priority: packaging.base_unit
			if (product && product.packaging && product.packaging.base_unit) {
				return product.packaging.base_unit
			}
			// Second priority: original_price_unit
			if (product && product.original_price_unit) {
				return product.original_price_unit
			}
			// Final fallback: single_item
			return 'single_item'
		}
	}
}
</script>

<style scoped>
@import '../styles/AddProductTransfer.css';
</style>
